import React, { ChangeEventHandler } from 'react';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import log from '../../../services/LogService';

const Wrapper = styled.div`
  width: 100%;
  position: relative;

  & > label {
    font-family: Rubik, sans-serif;
    font-size: 0.875rem;
    color: #1e4e5f;
    line-height: 2.5rem;
  }
`;

export const InputEl = styled.input`
  margin: 0;
  padding: 0.85rem 0.85rem 0.85rem 2rem;
  font-family: Rubik;
  font-size: 1rem;
  font-weight: 300;
  background-color: transparent;
  border-color: #1e4e5f;
  border-radius: 10px;
  border-width: 1px;
  text-align: left;
  color: #1a1919;
  outline: 0;
  width: 100%;
  box-sizing: border-box;
  line-height: 2rem;

  &[type='password'] {
    letter-spacing: 5px;
    font-size: 1rem;
    margin: 0;
    padding-top: 0.75rem;
    line-height: 2rem;
  }

  &[type='email'], &[type='email']:focus,
  &[type='email']:-webkit-autofill,
  &[type='email']:-webkit-autofill:hover,
  &[type='email']:-webkit-autofill:focus,
  &[type='email']:-webkit-autofill:active {
    margin: 0;
    padding: 0.85rem 0.85rem 0.85rem 2rem;
    font-family: Rubik, sans-serif;
    font-size: 1rem;
    font-weight: 300;
    background-color: transparent;
    border-color: #1e4e5f;
    border-radius: 10px;
    border-width: 1px;
    text-align: left;
    color: #1a1919;
    outline: 0;
    width: calc(100% - 1.7rem);
    box-sizing: border-box;
    line-height: 2rem;
    transition: background-color 600000s 0s, color 600000s 0s;
  }

  &[type='email']:invalid {
    border-color:red;
    border-width: 2px;
  }

`;

const ShowPassword = styled.div`
  text-decoration: underline;
  user-select: none;
  position: absolute;
  right: 0;
  bottom: 0;
  line-height: 1rem;
  font-weight: 600;
  font-size: var(--text-size-small);
  padding-bottom: 1.2rem;
  z-index: 6;
`;

interface InputProps {
  onChange?: ChangeEventHandler<HTMLInputElement>;
  type?: 'email' | 'password' | 'text';
  disabled?: boolean;
  title?: string;
  initialValue?: string;
  maxLength?: number;
  label?: string;
  placeholder?: string;
  oninvalid?: (event:Event) => void;
  minLength?: number;
}

const Input: React.FunctionComponent<InputProps> = (props) => {
  const { initialValue, onChange, title, type = 'text',
    maxLength = 21, placeholder, label, minLength = 0 } = props;
  const [inputValue, setInputValue] = useState(initialValue);
  const [showPassword, setShowPassword] = useState(false);
  const [isInputFocused, setIsInputFocused] = useState(false);
  log.info(`minLength: ${minLength}`);

  return (
    <Wrapper>
      {label && (
        <label htmlFor={type}>
          <FormattedMessage id={label} />
        </label>
      )}
      {type !== 'password' && (
        <InputEl
          defaultValue={inputValue}
          placeholder={placeholder}
          onFocus={() => setIsInputFocused(true)}
          onBlur={() => setIsInputFocused(false)}
          className="fpt-input"
          type={type}
          name={type}
          maxLength={maxLength}
          minLength={minLength}
          onChange={onChange}
        />
      )}
      {type === 'password' && (
        <>
          <InputEl
            defaultValue={inputValue}
            onFocus={() => setIsInputFocused(true)}
            onBlur={() => setIsInputFocused(false)}
            className="fpt-c-input"
            type={!showPassword ? 'password' : 'text'}
            name={type}
            maxLength={maxLength}
            minLength={minLength}
            onChange={onChange}
          />
          {inputValue != '' && (
            <ShowPassword onClick={() => setShowPassword((prev) => !prev)}>
              {!showPassword && <FormattedMessage id="input.component.show-password" />}
              {showPassword && <FormattedMessage id="input.component.hide-password" />}
            </ShowPassword>
          )}
        </>
      )}
    </Wrapper>
  );
};

export default Input;
